/**
 * @generated SignedSource<<6c2d23ce434bf1e6f90b637e148d07bc>>
 * @relayHash 1966b33d5ef8f314895fbeede75bf700
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dfbd793342a2f6636b6b714e36b0ccb21eb0f9912a662b3a4eaa26e191107693

import type { ConcreteRequest } from 'relay-runtime';
export type useIsEditorToolbarDockedAtTopEditorPreferencesQuery$variables = Record<PropertyKey, never>;
export type useIsEditorToolbarDockedAtTopEditorPreferencesQuery$data = {
  readonly userPreferences: {
    readonly confluenceEditorSettings: {
      readonly toolbarDockingInitialPosition: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useIsEditorToolbarDockedAtTopEditorPreferencesQuery = {
  response: useIsEditorToolbarDockedAtTopEditorPreferencesQuery$data;
  variables: useIsEditorToolbarDockedAtTopEditorPreferencesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "userPreferences",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceEditorSettings",
        "kind": "LinkedField",
        "name": "confluenceEditorSettings",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "toolbarDockingInitialPosition"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useIsEditorToolbarDockedAtTopEditorPreferencesQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useIsEditorToolbarDockedAtTopEditorPreferencesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "1966b33d5ef8f314895fbeede75bf700",
    "id": "dfbd793342a2f6636b6b714e36b0ccb21eb0f9912a662b3a4eaa26e191107693",
    "metadata": {},
    "name": "useIsEditorToolbarDockedAtTopEditorPreferencesQuery",
    "operationKind": "query",
    "text": "query useIsEditorToolbarDockedAtTopEditorPreferencesQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}"
  }
};
})();

(node as any).hash = "dd0b909642c1511dd33cee50b754da27";

export default node;
